
export const addPolicyTypeEndpoint = () =>
(`/api/policy-type`);

export const editPolicyTypeEndpoint = (policyTypeId: string) =>
(`/api/policy-type/${policyTypeId}`);

export const getPolicyTypeEndpoint = () =>
(`/api/policy-type`);

export const getPolicyTypeDetailsEndpoint = (policyTypeId: string) =>
(`/api/policy-type/${policyTypeId}`);

export const deletePolicyTypeEndpoint = (policyTypeId: string) =>
(`/api/policy-type/${policyTypeId}`);
